import { combineReducers } from 'redux';
import banksReducer from '../../main/apps/decisionLogic/store/banks';

// combinasr los entities aqui

const decisionLogic = combineReducers({
	banks: banksReducer,
});

export default decisionLogic;
